<template>
    <div @click="selectFile">
        <input
          type="file"
          ref="fileInput"
          v-show="false"
          @change="onFileChange"
        />
        <div>{{uploading?infoText:'上传文件'}}</div>
    </div>
</template>

<script>

export default {
    name: "oss-uploader",
    data() {
        return {
            uploading: false,
            infoText: "上传中...",
        }
    },
    methods: {
        selectFile() {//选择文件
            if (!this.uploading) {
                this.$refs.fileInput.click();
            }
        },
        onFileChange() {
            let file = this.$refs.fileInput.files[0];
            this.uploading = true;

          this.$uploadFile(file).then((res) => {
            this.uploading = false;
            this.$emit('uploaded', res.data.url);
          }).catch((err) => {
            this.uploading = false;
            // this.$message.error("文件上传失败：")
          });
        }
    }
}
</script>
